var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"board"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/img/atc.svg"),"usemap":"#image-map"}}),_c('map',{attrs:{"name":"image-map"}},_vm._l((_vm.links),function(link){return _c('area',{key:link.href,attrs:{"target":"_self","alt":link.alt,"title":link.title,"href":link.href,"coords":link.coords,"shape":"rect"}})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }